import { Segmented, SegmentedProps } from "antd";
import styles from "./index.module.css";

export const CustomSegmented = (props: SegmentedProps) => {
  return <Segmented className={styles.segmentedChoise} {...props} />;
};
